import React, { Component } from "react"
import { countrySelectorMeta } from "../util/billing_info_utils"

const CARD_COUNTRY_REGION_LABEL = "Country or region"

class CountrySelector extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const countryList = countrySelectorMeta()

        return (
            <div>
                <label className="billing-info-label">
                    {CARD_COUNTRY_REGION_LABEL}
                </label>
                <select className="billing-info-input form-control" id="country">
                    <option value="">Country</option>
                    {countryList.map((country, i) => (
                        <option data-power-region={country.region} value={country.name} key={i}>
                            {country.name}
                        </option>
                    ))}
                </select>
            </div>
        )
    }
}

export default CountrySelector



// WEBPACK FOOTER //
// ./src/components/country_selector.jsx